var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVeteran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.78516 4.43779L4.40985 5.08766L6.03457 4.43779V0H2.78516V4.43779Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40985 11.3729C5.30715 11.3729 6.03455 10.6455 6.03455 9.74824C6.03455 8.85094 5.30715 8.12354 4.40985 8.12354C3.51256 8.12354 2.78516 8.85094 2.78516 9.74824C2.78516 10.6455 3.51256 11.3729 4.40985 11.3729Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82004 0.4642C8.81928 0.208141 8.61189 0.00075956 8.35584 0H6.49902V4.25211L8.38136 3.5001C8.64709 3.39532 8.82127 3.13818 8.82004 2.85254V0.4642Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7761e-06 2.85252C-0.00125192 3.13816 0.172948 3.3953 0.438685 3.50008L2.32103 4.25208V0H0.464207C0.208148 0.00075956 0.000766336 0.208141 6.7761e-06 0.4642V2.85252Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.4553 8.52046C1.38516 8.5 1.30949 8.51376 1.25104 8.55759C1.1926 8.60143 1.1582 8.67022 1.1582 8.74327L1.16053 10.7533C1.16111 10.8261 1.19564 10.8945 1.25391 10.9382C1.31218 10.9819 1.38753 10.9959 1.4576 10.9761L2.53223 10.6604C2.2506 10.0849 2.2506 9.4116 2.53223 8.83611L1.4553 8.52046Z",
    fill: "#757575"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36273 10.9761C7.43282 10.9959 7.50815 10.9819 7.56642 10.9382C7.62469 10.8945 7.65924 10.8261 7.6598 10.7533L7.66212 8.74327C7.66212 8.67022 7.62773 8.60143 7.56928 8.55759C7.51084 8.51376 7.43517 8.5 7.36503 8.52046L6.28809 8.83611C6.56971 9.41162 6.56971 10.0849 6.28809 10.6604L7.36273 10.9761Z",
    fill: "#757575"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18168 6.79592L3.49733 7.87054C4.07284 7.58892 4.74616 7.58892 5.32165 7.87054L5.6373 6.79592C5.65713 6.72582 5.64314 6.65049 5.59943 6.59223C5.55572 6.53396 5.48732 6.49941 5.41449 6.49884L4.42341 6.49652C4.41877 6.49652 4.41412 6.49884 4.40948 6.49884C4.40483 6.49884 4.40019 6.49652 4.39555 6.49652L3.40447 6.49884C3.33162 6.49943 3.26324 6.53396 3.21953 6.59223C3.17584 6.65049 3.16185 6.72584 3.18168 6.79592V6.79592Z",
    fill: "#757575"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40996 11.8372C4.09379 11.8372 3.78178 11.765 3.49779 11.626L3.18214 12.7029C3.16168 12.7731 3.17544 12.8487 3.21928 12.9072C3.26311 12.9656 3.33191 13 3.40495 13H5.41495C5.48799 13 5.55679 12.9656 5.60063 12.9072C5.64446 12.8487 5.65822 12.7731 5.63776 12.7029L5.32211 11.626C5.03814 11.765 4.72613 11.8372 4.40996 11.8372V11.8372Z",
    fill: "#757575"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40951 6.26672C4.66588 6.26672 4.87371 6.05889 4.87371 5.80252C4.87371 5.54615 4.66588 5.33832 4.40951 5.33832C4.15314 5.33832 3.94531 5.54615 3.94531 5.80252C3.94531 6.05889 4.15314 6.26672 4.40951 6.26672Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeteran);
export default __webpack_public_path__ + "static/media/Veteran.066db71be704e69866601d78996fffde.svg";
export { ForwardRef as ReactComponent };